import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import Breadcrumbs from '../../../../common/widgets/Breadcrumbs';
import applicationCrumbs from '../ApplicationCrumbs';
import PlatformInformation from '../Common/PlatformInformation';
import AdminMenu from './Common/AdminMenu';
import TutorialsPanel, { TutorialsPanelProps } from '../TutorialsPanel';
import { useEffect, useState } from 'react';

export default function AdminAccount() {
  const { t: translate } = useTranslation();
  const crumbs = applicationCrumbs(translate);
  const location = useLocation();

  const [tutorialPanelProps, setTutorialPanelProps] =
    useState<TutorialsPanelProps>({
      isVisible: false,
      categoryId: undefined,
      currentRoute: undefined,
      forMobile: false,
    });

  useEffect(() => {
    setTutorialPanelProps(prev => ({
      ...prev,
      currentRoute: location.pathname,
    }));
  }, [location.pathname]);

  return (
    <>
      <Breadcrumbs entries={[crumbs.home, crumbs.admin]} />
      <section className="section-main section-actions admin-page">
        <div className="container">
          <div className="area-actions">
            <AdminMenu />
          </div>
          <div className="area-content">
            <PlatformInformation />
            <Outlet context={{ setTutorialPanelProps }} />
          </div>
        </div>
      </section>
      <TutorialsPanel {...tutorialPanelProps} />
    </>
  );
}
